import React from 'react';
import ReserveFieldDateMultiple from '@/components/reserve/ReserveFieldDateMultiple/ReserveFieldDateMultiple';
import ReserveFieldStartDate from '@/components/reserve/ReserveFieldStartDate/ReserveFieldStartDate';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';

export const ReserveFormDates: React.FC = () => {
  const {
    office,
    isMeetingRoom,
    form,
    weekDates,
    currentOfficeTz,
    resourceType,
    startTime
  } = useReserveForm();

  // TODO: Fix this - it was coming from SvgMapView
  const modalRef = React.useRef<HTMLDivElement>(null);

  return (
    <div className="">
      {office ? (
        !isMeetingRoom ? (
          <ReserveFieldDateMultiple
            form={form}
            weekDates={weekDates}
            officeTimeZone={currentOfficeTz}
            errors={form.formState.errors}
            resType={resourceType}
            office={office}
            modalRef={modalRef}
          />
        ) : (
          <ReserveFieldStartDate
            form={form}
            defaultValue={weekDates}
            startTime={startTime}
            weekDates={weekDates}
            officeTimeZone={currentOfficeTz}
            errors={form.formState.errors}
            resType={resourceType}
            office={office}
          />
        )
      ) : null}
    </div>
  );
};
